import { NavBar, Text, Button, Drawer } from '@sede-enterprise/shell-ds-react-framework'
import { Bell } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components'
import React, { useState, useEffect } from 'react'
import './TopNav.css'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom'
import Notifications from '../Notifications/Notifications'
import useGetNotification from './useGetNotification'
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from "@azure/msal-browser";



const TopNav = () => {
    const { instance, inProgress } = useMsal();
    const [name, setName] = useState(null);
    const activeAccount = inProgress === InteractionStatus.None ? instance.getActiveAccount() : null;
    useEffect(() => {
        if (activeAccount) {
            const fullnameSplit = activeAccount.name.split(',');
            const firstName = fullnameSplit[1].trim().split(" ")[0];
            const lastName = fullnameSplit[0].trim();
            setName(firstName + ' ' + lastName);
        } else {
            setName(null);
        }
    }, [activeAccount]);


    
    const history = useHistory()

    const { pathname } = useLocation();
    const { notifications, loading, markAsRead, markAllAsRead } = useGetNotification(pathname);
    console.log("notifications in topnav", notifications);
    // Drawer controls
    const [open, setOpen] = useState(false);
    const handleOnClick = () => {
        setOpen(true);
    };
    const handleOnClose = () => {
        setOpen(false);
    };
    return (
        <NavBar elevation className='header-nav' id='header-nav-id-1'>
            <div className='header-container' id='header-nav-id-2'>
                <div className='header-title' id='header-nav-id-3'>
                    <h3 id='header-nav-id-4'>CARMA</h3>
                    <Text prominence='subtle' size='small' id='header-nav-id-5'>Corrosion Advanced Risk Modelling & Analytics</Text>
                </div>
                <div className='alert-info' id='header-nav-id-6'>
                    {name &&
                        <div className='header-user-info'>
                            <div style={{padding: '15px 0'}}>
                                Hello, {name}
                            </div>
                        </div>
                    }
                    
                    {(pathname === '/' || pathname === '/home') &&
                        <Button sentiment='neutral' variant='transparent' icon={<Bell height={25} width={25} id='header-nav-id-7' />}
                            onClick={handleOnClick}
                            size='large'
                            id='header-nav-id-8'>
                            {notifications.length > 0 && notifications.length}
                        </Button>
                    }
                </div>
            </div>
            <Drawer open={open} onClose={handleOnClose} header='Alerts'
                actions={[{
                    label: 'Mark All as Read',
                    action: () => {
                        markAllAsRead();
                        handleOnClose();
                    },
                    props: {
                        variant: 'outlined',
                    }
                },
                {
                    label: 'View All',
                    action: () => {
                        history.push('/alerts')
                        handleOnClose();
                    }
                }]}
                id='header-nav-id-9'
            >
                <Notifications alerts={notifications} loading={loading} markAsRead={markAsRead} closeNotifications={handleOnClose} id='header-nav-id-10' />
            </Drawer>

        </NavBar>
    )
}

export default TopNav